<section class="flex flex-row flex-center items-center justify-center empty-wrapper">
  <div
    class="flex flex-col flex-center items-center justify-center w-full h-full gap-2 mx-auto empty-container"
    *transloco="let t"
  >
    @if (hideIcon() === false) {
      @if (fontIcon()) {
        <div
          class="flex rounded-[6px] bg-gray-200 text-xs font-bold justify-center items-center"
          [style.height]="size() + 'px'"
          [style.width]="size() + 'px'"
        >
          <mat-icon
            [style.height]="iconSize() + 'px'"
            [style.width]="iconSize() + 'px'"
            [style.fontSize]="iconSize() + 'px'"
            class="mat-icon-outlined"
            >{{ fontIcon() }}</mat-icon
          >
        </div>
      } @else {
        <div
          [style.height]="size() + 'px'"
          [style.width]="size() + 'px'"
          [style.fontSize]="size() + 'px'"
          class="flex rounded-[6px] bg-gray-200 text-xs font-bold justify-center items-center"
        ></div>
      }
    }
    <div class="flex flex-col flex-center items-center justify-center w-full gap-2 mt-2">
      @if (hideHeader() === false) {
        <h3 class="text-sm font-semibold">{{ t(scope() + '.empty.title') }}</h3>
      }
      @if (hideSubHeader() === false) {
        <small class="text-sm font-normal text-center">{{ t(scope() + '.empty.small') }}</small>
      }
    </div>
    <ng-content></ng-content>
  </div>
</section>
